// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"7244ed95","195":"1989e519","320":"6f859cf3"}[chunkId] + ".chunk.js";
};